export default "__VITE_ASSET__lxsd1nkd__"